import React, { Component } from "react";
import "./styles/Home.css";
import AdListSkeleton from "../components/AdListSkeleton";
import AdList from "../components/AdList";
import AdMenu from "../components/AdMenu";
import { connect } from "react-redux";
import * as actions from "../redux/actions/mostSearchedAdsActions";
import SummaryByCountry from "../components/SummaryByCountry";
import Footer from "../components/Footer";
import { Translate } from "react-redux-i18n";

class HomeMostSearchedAds extends Component {
  componentDidMount() {
    if (this.props.user_id && this.props.token) {
      this.props.LoadList(this.props.user_id, this.props.token);
    }
  }

  componentWillUnmount() {}

  render() {
    const isLoggedIn = Boolean(this.props.user_id && this.props.token);
    const showEmpty =
      !this.props.loading && (!this.props.adList || this.props.adList.length === 0);

    return (
      <React.Fragment>
        <div className="Home-in">
          <div className="col-lg-3 d-none d-lg-block ">
            <div className="Home-left">
              <AdMenu />
              {isLoggedIn && <SummaryByCountry />}
            </div>
          </div>
          <div className="col-lg-9 ">
            {this.props.loading ? (
              <AdListSkeleton count={8} />
            ) : showEmpty ? (
              <div className="transaction-list__empty">
                <Translate value="ad_search_not_list" />
              </div>
            ) : (
              <AdList adList={this.props.adList} />
            )}
          </div>
        </div>
        <Footer />
      </React.Fragment>
    );
  }
}

function mapStateToProps(reducer) {
  return {
    user_id: reducer.session.auth.id,
    token: reducer.session.auth.access_token,
    adList: reducer.mostSearchedAds.list,
    loading: reducer.mostSearchedAds.loading && !reducer.mostSearchedAds.loaded,
    error: reducer.mostSearchedAds.error,
  };
}

const mapDispatchToProps = (dispatch) => ({
  LoadList: (user_id, token) =>
    dispatch(actions.loadList({ user_id, token })),
});

export default connect(mapStateToProps, mapDispatchToProps)(HomeMostSearchedAds);
